import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'mapfre-auditlib-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {

  constructor() { }
  @Input() item;
  public show: boolean = false;
  @Output() clicked = new EventEmitter<number>();

  ngOnInit() {
  }


  public onItemClicked(item) {
    this.show = !this.show;
    this.clicked.emit(item);
  }

  public onSubItemClicked(item) {
    this.clicked.emit(item);
  }

}
